import Contact from '@/classes/Contact';
import ContactList from '@/classes/ContactList';

export default {
  setContacts(state, contacts) {
    state.contacts = contacts.map(contact => new Contact(contact));
  },

  addContacts(state, contacts) {
    contacts
      .map(contact => new Contact(contact))
      .forEach(contact => {
        state.contacts.push(contact);
      });
  },

  setContactNotes(state, { contactId, data }) {
    const contact = state.contacts.find(contact => contact.id === contactId);
    if (contact) {
      contact.notes = data.map(note => {
        return {
          ...note,
          creator: new Contact({
            id: note.creatorId,
            firstName: note.creatorName
          })
        };
      });
    }
  },

  setContactLists(state, lists) {
    state.lists = lists.map(list => new ContactList(list)).sort(ContactList.compare);
  },

  removeContact(state, contactId) {
    state.contacts = state.contacts.filter(contact => contact.id !== contactId);
  },

  removeList(state, listId) {
    state.lists = state.lists.filter(list => list.id !== listId);
  }
};
